import React from "react";
import { Reveal, Eyebrow } from "./MarketingUI";
import { UserCheck, PenLine, Eye, Bell, BarChart3 } from "lucide-react";

const features = [
  { icon: UserCheck, title: "Assignments", desc: "Route legislation to the appropriate staff, with primary ownership and clear accountability." },
  { icon: PenLine, title: "Internal Analysis", desc: "Keep institutional analysis and working notes connected directly to the bill." },
  { icon: Eye, title: "Watchlists", desc: "Focus teams on the legislation that matters most to your organization." },
  { icon: Bell, title: "Alerts", desc: "Stay informed the moment legislative activity changes." },
  { icon: BarChart3, title: "Reports", desc: "Turn legislative activity into actionable information for leadership." },
];

export default function Team() {
  return (
    <section className="relative overflow-hidden bg-brand-civic-50 py-24 sm:py-28" data-testid="team-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-3xl">
          <Reveal><Eyebrow>Built around the team</Eyebrow></Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-4 font-display text-3xl font-extrabold leading-tight tracking-tight text-brand-ink sm:text-4xl">
              Tracking legislation is only the beginning.
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-4 max-w-2xl text-base leading-relaxed text-brand-slate">
              GovFlowState connects legislative information to the people responsible for acting on it.
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {features.map((f, i) => (
            <Reveal key={f.title} delay={0.06 * i} className={i === 0 ? "lg:row-span-2" : ""}>
              <div className={`flex h-full flex-col rounded-2xl border border-brand-line bg-white p-6 shadow-card transition-shadow hover:shadow-elevated ${i === 0 ? "lg:justify-between lg:bg-brand-navy" : ""}`} data-testid={`team-feature-${i}`}>
                <span className={`grid h-12 w-12 place-items-center rounded-xl ${i === 0 ? "bg-white/10" : "bg-brand-teal-50"}`}>
                  <f.icon className={`h-6 w-6 ${i === 0 ? "text-brand-gold" : "text-brand-teal"}`} strokeWidth={1.8} />
                </span>
                <div className={i === 0 ? "mt-8" : "mt-5"}>
                  <h3 className={`font-display text-lg font-bold ${i === 0 ? "text-white" : "text-brand-ink"}`}>{f.title}</h3>
                  <p className={`mt-2 text-sm leading-relaxed ${i === 0 ? "text-white/65" : "text-brand-slate"}`}>{f.desc}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
